export const formUpload = {
  SINGLE: 0,
  MANY: 1
};
